import { __rest } from "tslib";
import React from 'react';
import { default as getVariationsFromProps } from "@pb/utils/common/getVariationsFromProps";
import cn from 'classnames';
import styles from './IconWrapper.module.scss';
const defaultViewBox = '0 0 24 24';
const IconWrapper = (_a) => {
    var { children, className, size = 'normal', role, viewBox = defaultViewBox, fill } = _a, props = __rest(_a, ["children", "className", "size", "role", "viewBox", "fill"]);
    if (!children)
        return null;
    const [variationsClassNames, passableProps] = getVariationsFromProps(props, styles);
    return (React.createElement("svg", Object.assign({ className: cn(styles.icon, className, variationsClassNames, styles[size]), viewBox: viewBox, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", focusable: "false", role: role, fill: fill }, passableProps), children));
};
export default IconWrapper;
//# sourceMappingURL=IconWrapper.js.map